import { create } from "zustand";

type UseMenuStoreProps = {
    isOpenSearch : boolean;
    isOpenCart   : boolean;
    isOpenMenu   : boolean;
    isOpenFilter : boolean;
    toggleCart   : () => void;
    toggleMenu   : () => void;
    toggleSearch : () => void;
    openCart     : () => void;
    toggleFilter : () => void;
    closeSearch  : () => void;
    closeMenu    : () => void;
    closeCart    : () => void;
};

export const useMenuStore = create<UseMenuStoreProps>((set:any) => 
    ({
        isOpenFilter : false,
        isOpenSearch : false,
        isOpenCart   : false,
        isOpenMenu   : false,
        toggleMenu   : () => set((state:any) => ({ isOpenMenu : !state.isOpenMenu })),
        toggleCart   : () => set((state:any) => ({ isOpenCart : !state.isOpenCart })),
        toggleSearch : () => set((state:any) => ({ isOpenSearch : !state.isOpenSearch })),
        closeSearch  : () => set(() => ({ isOpenSearch : false })),
        closeCart    : () => set(() => ({ isOpenCart : false })),
        closeMenu    : () => set(() => ({ isOpenMenu : false })),
        toggleFilter : () => set((state:any) => ({ isOpenFilter : !state.isOpenFilter })),
        openCart     : () => set(() => ({ isOpenCart : true })),
    }));